import { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import MainView from "views/MainView";
import {
  _H5Event,
  handleFromAppParams,
  deviceInfo,
  IDeviceInfo,
  IDeviceBody,
} from "request";
import { useIntlContext, SupportedLocales } from "views/IntlContext";

const DeviceInfoPage = () => {

  const { switchLanguage } = useIntlContext();

  const [devices, setDevices] = useState<IDeviceInfo | undefined>(
    undefined
  );

  const onGetDeviceInfo = (data: IDeviceBody) => {
    deviceInfo(data)
      .then((response: any) => {
        if (response?.code === "200") {
          setDevices(response.result);
        }
      })
      .catch((err: any) => console.log(err));
  };

  useEffect(() => {
    const datas = {
      event: "GetDeviceInitParams",
      pageName: "device",
      callback: (responseStr: any) => {
        const jsonData = handleFromAppParams(responseStr);
        switchLanguage?.(jsonData.lang as SupportedLocales);
        onGetDeviceInfo(jsonData);
      },
    };
    _H5Event(datas);
  }, []);

  return (
    <MainView backgroundClassName="bg-page dark:bg-black1b1f1e">
      <div className="h-3 w-full bg-page dark:bg-black1b1f1e"></div>
      <div className="bg-white dark:bg-gray323434 border-b border-solid border-[#F2F2F2] dark:border-gray484848 flex flex-row justify-between items-center px-5 py-3">
        <span>
          <FormattedMessage id="device.name" />
        </span>
        <span className="text-gray666 dark:text-white60">
          {devices?.nickname || ""}
        </span>
      </div>
      <div className="bg-white dark:bg-gray323434 border-b border-solid border-[#F2F2F2] dark:border-gray484848  flex flex-row justify-between items-center px-5 py-3">
        <span>
          <FormattedMessage id="device.bluetooth.version" />
        </span>
        <span className="text-gray666 dark:text-white60">
          {devices?.name || ""}
        </span>
      </div>
      <div className="bg-white dark:bg-gray323434 flex flex-row justify-between items-center px-5 py-3">
        <span>
          <FormattedMessage id="device.model" />
        </span>
        <span className="text-gray666 dark:text-white60">
          {devices?.productModel || ""}
        </span>
      </div>
      {devices?.mcuVersion && (
        <div className="bg-white dark:bg-gray323434 flex flex-row justify-between items-center px-5 py-3">
          <span>
            <FormattedMessage id="device.mcuVersion" />
          </span>
          <span className="text-gray666 dark:text-white60">
            V{devices?.mcuVersion || ""}
          </span>
        </div>
      )}
    </MainView>
  );
};

export default DeviceInfoPage;
